import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional class names, with later Tailwind utilities beating earlier ones of
 * the same kind.
 *
 * `clsx` alone would leave `px-2 px-4` in the string and let the cascade decide,
 * which makes a `className` override on a component silently depend on the order
 * Tailwind happened to emit the two rules in. `twMerge` resolves it by utility
 * group instead, so a caller's `className` always wins.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
